"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextButton = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.TextButton = function (_a) {
    var children = _a.children, rest = tslib_1.__rest(_a, ["children"]);
    return react_1.default.createElement(StyledButton, tslib_1.__assign({}, rest), children);
};
var StyledButton = styled_components_1.default.span(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  text-transform: uppercase;\n  line-height: 1.5rem;\n  font-size: 1.2rem;\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  font-family: ", ";\n  color: ", ";\n\n  &:hover {\n    text-decoration: underline;\n    color: ", ";\n  }\n"], ["\n  text-transform: uppercase;\n  line-height: 1.5rem;\n  font-size: 1.2rem;\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  font-family: ", ";\n  color: ", ";\n\n  &:hover {\n    text-decoration: underline;\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoMedium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[900];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.green[500];
});
var templateObject_1;
